import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{ SeoService, AppContext } from './../../shared';

@Component({
  selector: 'privacy-policy',
  template: require('./privacy-policy.component.html'),
  styles: [require('./privacy-policy.component.scss'), require('../static.scss')]
})
export class PrivacyPolicyComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute,  private seo: SeoService, private app: AppContext) {
    // Do stuff
  }

  title = 'Linescape Privacy Policy';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessels or carrier.';
  
  ngOnInit() {
    this.seo.set(this.title, this.description);
  }

  loginToggle() {
    this.app.toggleLogin();
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/privacy-policy/privacy-policy.component.ts